import { Avatar, Box, Flex, Stack, Text, useColorModeValue,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  Button,
  PopoverBody, 
} from "@chakra-ui/react";
import { Collapse } from "@chakra-ui/transition";
import { BsArrowRightCircleFill, BsDashCircleDotted, BsThreeDotsVertical } from "react-icons/bs";
import { FiArrowLeftCircle } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import useSmallScreen from "../../components/useSmallScreen";
import thelogo from "../../assets/thelogo.png"
import GroupMembers from "./GroupMembers";
import { addSingleUserToGroup, deleteGroup, exitGroup, getOtherUsersNotInGroup } from "../dashboard/tradingGroup/service";
import { errorNotifier, successNotifier } from "../..";
import { useEffect, useState } from "react";
import AddMembersModal from "../dashboard/tradingGroup/AddMembersModal";
import DeleteGroupModal from "../../components/profile/components/DeleteGroupModal";
import ShareGroupModal from "../../components/profile/components/ShareGroupModal";
import { useGetState } from "../../context/useGetState";

// Function to generate a slug from text
const slugify = (text) => {
  return text?.toLowerCase().replace(/ /g, "-");
};

function UserChatDetails({ setShowChatDetails, setGroups, groups, chats, user, isOpen, currentGroupChat, ...props }) {
  const [loading, setLoading] = useState(false);
  const { state } = useGetState();
  const userInfo = state?.userInfo;

  const chatContainer2Bg = useColorModeValue("#fff", "#020B19");
  const text1Color = useColorModeValue("#4B5155", "#fff");
  const text2Color = useColorModeValue("#4B5155", "#707070");
  const arrowColor = useColorModeValue("#AFBBC6", "#AFBBC6");
  const [smallScreen] = useSmallScreen();
  const [groupMembers, setGroupMembers] = useState([]);
  const [otherUsers, setOtherUsers] = useState([]);
  const [addMembersModalOpen, setAddMembersModalOpen] = useState(false);
  const [deleteGroupModalOpen, setDeleteGroupModalOpen] = useState(false);
  const [shareGroupModalOpen, setShareGroupModalOpen] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);

  const navigate = useNavigate();

  const handleExitGroup = async () => {
    setLoading(true);
    await exitGroup(currentGroupChat?.invite_link)
      .then((data) => {
        setLoading(false);
        successNotifier(`Successfully Exited from ${currentGroupChat?.name}`);
        //console.log('groupdata:',data?.data);
        navigate("/groups");
      })
      .catch((e) => {
        setLoading(false);
        errorNotifier(`${e?.response?.data?.message}`);
        return;
        
      });
  };

  useEffect(() => {
    setGroupMembers(currentGroupChat?.members)
  }, [currentGroupChat]);

  useEffect(() => {
    const fetchOtherUsersData = async () => {
      try {
        if (currentGroupChat) {
          const othersRes = await getOtherUsersNotInGroup(currentGroupChat?.id);
          //console.log('others: ',othersRes?.data?.data);
          setOtherUsers(othersRes?.data?.data)
        } else {
          setOtherUsers([])
        }
        
      } catch (error) {
        console.log('error: ', error);
      }
    }
    fetchOtherUsersData();
  }, [currentGroupChat]);

  const slug = slugify(currentGroupChat?.name)

  //store in state
  const gotoGroupEdit = (updatedGroup) => {
    //console.log('gotoGroup: ', 'gotoGroup');
    navigate(`/groups/${slug}`, { state: { groupData: currentGroupChat } });
  }

  //delete group
  const handleGroupDelete = (selectedGroup) => {
    try {
      const res = deleteGroup(selectedGroup?.id);
      setLoading(false);
      // Create a new array that excludes selectedMember
      const updatedGroups = groups.filter(
        (group) => group.id !== selectedGroup.id
      );

      // Update the state with the new array
      setGroups(updatedGroups);
      //setDeleteGroupModalOpen(false)
      successNotifier(`Successfully Deleted ${selectedGroup?.name}`);
    } catch (error) {
      console.log('error: ', error);
    }
  }

  //Add members
  const handleAddMember = async (usersToAdd) => {
        
    //const res = await follow(userIdToRemove, setBtnLoading)
    //console.log('handleAddMember: ', '["1","2","3"]');
    
  };

  const handleAddSingleMember = async (selectedMember) => {
    try {
      let res = await addSingleUserToGroup(currentGroupChat?.id, selectedMember?.id);
      setLoading(false);
      
      // Create a new array that excludes selectedMember
      const updatedOtherUsers = otherUsers.filter(
        (user) => user.id !== selectedMember.id
      );

      // Update the state with the new array
      setOtherUsers(updatedOtherUsers);

      // Create a new array with selectedMember at the beginning
      const updatedGroupMembers = [selectedMember, ...groupMembers];

      // Set the state with the new array
      setGroupMembers(updatedGroupMembers);

      successNotifier(`Successfully Added Member To ${currentGroupChat?.name}`);
      setAddMembersModalOpen(false)
    } catch (error) {
      console.error("Error:", error);
    }
  }

  return (
    
    <Stack
      position={"relative"}
      flex="1"
      bg={chatContainer2Bg}
      p="10px"
      borderRadius={"5px"}
      spacing="30px"
      height={window.innerHeight - 100}
      maxH={window.innerHeight - 100}
      w={["100%", "unset"]}
      overflow={"scroll"}
      className="scroll-container"
      {...props}
    >
      
      <Flex
        flexDirection={"row"}
        alignItems="center"
        justifyContent={"space-between"}
      >
        {smallScreen && (
          <FiArrowLeftCircle
            fontSize={"2em"}
            cursor={"pointer"}
            onClick={() => props?.setCurrentMobileScreenState(0)}
          />
        )}{" "}
        <Stack direction={"row"} justifyContent={"space-between"} alignItems="center">
          <Stack direction={"row"} alignItems="center">
            <Text color={text2Color}>Join New Group</Text>
            
            <BsArrowRightCircleFill
              color={arrowColor}
              fontSize={"2em"}
              cursor="pointer"
              onClick={() => navigate("/groups")}
            />
          </Stack>
          
          

          <Popover
            closeOnBlur={true}
            placement='bottom'
            >
            <PopoverTrigger>
              <Stack
                style={{ border:"1px solid #fff", borderRadius:"50%", padding:"2px", marginLeft:"1em" }}
              >
                <BsThreeDotsVertical
                color={arrowColor}
                fontSize={"1.5em"}
                cursor="pointer"
                />
              
              </Stack>
            </PopoverTrigger>
            <PopoverContent color='white' bg='#07182E' border='0' width={"100%"}>
              <PopoverArrow />
              <PopoverBody border='0'>
                {/* Add your popover content here, e.g., a menu */}
                <Stack
                    display='block'
                    alignItems='center'
                    justifyContent='space-between'
                >
                  {parseInt(currentGroupChat?.creator?.id) === userInfo?.id && <Box fontSize='xs' textAlign={'center'} cursor={'pointer'}
                  onClick={() => setAddMembersModalOpen(true)} 
                  >Add New User</Box>}

                  {parseInt(currentGroupChat?.creator?.id) === userInfo?.id && <Box fontSize='xs' textAlign={'center'} cursor={'pointer'}
                  onClick={() => {gotoGroupEdit(currentGroupChat)}}
                  >Edit Group</Box>}

                  <Box fontSize='xs' textAlign={'center'} cursor={'pointer'}
                  onClick={() => setShareGroupModalOpen(true)}
                  >
                    Share This Group
                  </Box>

                  {parseInt(currentGroupChat?.creator?.id) === userInfo?.id && <Box fontSize='xs' textAlign={'center'} color={'red'} cursor={'pointer'}
                  onClick={() => setDeleteGroupModalOpen(true)}
                  >Delete Group</Box>}
                </Stack>
                
              </PopoverBody>
            </PopoverContent>
          </Popover>
          
        </Stack>
      </Flex>

      {chats ? (
        <Stack direction={"row"} alignItems="flex-start">
          <Avatar
            border="3px solid #fff"
            objectFit={"cover"}
            src={chats?.picture}
            name={chats?.name}
            alt="random user pic"
            fallbackSrc={thelogo}
          />
          <Stack flex="3" alignItems={"flex-start"} spacing="0">
            <Text color={text1Color}>{chats?.name}</Text>
            <Text color="#AFBBC6" fontSize={".7em"}>
              {chats?.members?.length} members
            </Text>
          </Stack>
        </Stack>
      ) : (
        <Text>
          You dont belong to any group yet, Go to all groups to join a group
        </Text>
      )}
      <Text
        alignSelf={"center"}
        w="fit-content"
        bg="#FF686B"
        color="#fff"
        borderRadius={"20px"}
        p="8px 20px"
        mb="30px !important"
        fontSize={".9em"}
        cursor="pointer"
        onClick={() => navigate("/meetings", { state: { groupMeeting: true } })}
      >
        Host a meeting
      </Text>

      <GroupMembers groupChat={chats} groupMembers={groupMembers} user={user} />

      <Box
        position={"absolute"}
        bottom={"0"}
        right={"0"}
        color={"red"}
        cursor={"pointer"}
        onClick={handleExitGroup}
        isLoading={loading}
      >
        Exit Group
      </Box>

      <AddMembersModal
        authUserId={userInfo?.id} groupData={currentGroupChat} otherUsers={otherUsers} 
        handleAddMember={handleAddMember} handleAddSingleMember={handleAddSingleMember}
        isOpen={addMembersModalOpen} onClose={() => setAddMembersModalOpen(false)} 
      />
      <DeleteGroupModal
        authUserId={userInfo?.id} groupData={currentGroupChat} handleGroupDelete={handleGroupDelete} setIsDeleted={setIsDeleted}
        isOpen={deleteGroupModalOpen} onClose={() => setDeleteGroupModalOpen(false)} 
      />
      <ShareGroupModal
        authUserId={userInfo?.id} groupData={currentGroupChat}
        isOpen={shareGroupModalOpen} onClose={() => setShareGroupModalOpen(false)} 
      />

    </Stack>
    
  );
}

export default UserChatDetails;
